"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _axios = _interopRequireDefault(require("axios"));

var _lodash = require("lodash");

var _reactUseKeypress = _interopRequireDefault(require("react-use-keypress"));

var _PageWrapper = _interopRequireDefault(require("../components/PageWrapper"));

var _Loader = _interopRequireDefault(require("../components/Loader"));

var _EditorSidebar = _interopRequireDefault(require("../components/EditorSidebar"));

var _utils = require("../utils");

var _store = require("../store");

var _actions = require("../actions");

var _templateObject, _templateObject2;

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var PostEditor = function PostEditor(props) {
  var _sites$siteID2;

  var defaultComponent = props.defaultComponent;

  var _ref2 = (0, _store.useStore)(),
      _ref3 = _slicedToArray(_ref2, 2),
      _ref3$ = _ref3[0],
      config = _ref3$.config,
      _ref3$$cmsState = _ref3$.cmsState,
      sites = _ref3$$cmsState.sites,
      siteID = _ref3$$cmsState.siteID,
      _ref3$$editorState = _ref3$.editorState,
      site = _ref3$$editorState.site,
      post = _ref3$$editorState.post,
      dispatch = _ref3[1];

  var fields = config.fields;

  var previewID = _utils.auth.isPreview();

  var _ref4 = (0, _react.useState)(null),
      _ref5 = _slicedToArray(_ref4, 2),
      query = _ref5[0],
      setQuery = _ref5[1];

  var _ref6 = (0, _react.useState)(!previewID),
      _ref7 = _slicedToArray(_ref6, 2),
      sidebarActive = _ref7[0],
      setSidebarActive = _ref7[1];

  var template = (0, _utils.getTemplateByPost)(post, fields);
  var Component = template === null || template === void 0 ? void 0 : template.component;
  var pathname = window.location.pathname.replace(/\/$/, '');

  var isNumber = function isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }; // The post id is only available during initial load so we need to look it up ourselves by searching through all pages


  var postID = (0, _react.useMemo)(function () {
    var postID = '';

    if (sites[siteID]) {
      Object.values(sites[siteID].postTypes).map(function (o) {
        return Object.values(o.posts).map(function (p) {
          var _sites$siteID;

          var slug = (0, _utils.generateSlug)(o, p.id, sites === null || sites === void 0 ? void 0 : (_sites$siteID = sites[siteID]) === null || _sites$siteID === void 0 ? void 0 : _sites$siteID.frontPage, true);

          if (slug === "".concat(pathname, "/")) {
            postID = p.id;
          } else if ( // We're assuming here that there is not conflicting page which has the format '/[blog]/page/2'
          pathname.includes(slug) && pathname.includes('page') && isNumber(pathname.substring(pathname.lastIndexOf('/') + 1))) {
            postID = p.id;
          }
        });
      });
    }

    return postID;
  }, [pathname]); // We need to check if post is front page to return the correct basePath for pagination

  var isFrontPage = postID === (sites === null || sites === void 0 ? void 0 : (_sites$siteID2 = sites[siteID]) === null || _sites$siteID2 === void 0 ? void 0 : _sites$siteID2.frontPage); // The pagination object will be available once we have the post id and therefore template id

  var pagination = (0, _react.useMemo)(function () {
    var pagination = {};

    if ((template === null || template === void 0 ? void 0 : template.id) === 'archive') {
      var _config$settings, _sites$siteID3, _sites$siteID3$postTy, _sites$siteID3$postTy2; // Get the page number if exists


      var page = isNumber(pathname.substring(pathname.lastIndexOf('/') + 1)) ? parseInt(pathname.substring(pathname.lastIndexOf('/') + 1)) : 1;
      var postsPerPage = (config === null || config === void 0 ? void 0 : (_config$settings = config.settings) === null || _config$settings === void 0 ? void 0 : _config$settings.postsPerPage) || 10;
      var numberOfPosts = Object.values((sites === null || sites === void 0 ? void 0 : (_sites$siteID3 = sites[siteID]) === null || _sites$siteID3 === void 0 ? void 0 : (_sites$siteID3$postTy = _sites$siteID3.postTypes) === null || _sites$siteID3$postTy === void 0 ? void 0 : (_sites$siteID3$postTy2 = _sites$siteID3$postTy[template === null || template === void 0 ? void 0 : template.postTypeID]) === null || _sites$siteID3$postTy2 === void 0 ? void 0 : _sites$siteID3$postTy2.posts) || {}).filter(function (o) {
        return o.status === 'publish';
      }).length;
      pagination = {
        basePath: isFrontPage ? '/' : "/".concat(post.slug, "/"),
        numberOfPosts: numberOfPosts,
        postsPerPage: postsPerPage,
        numberOfPages: Math.ceil(numberOfPosts / postsPerPage),
        page: page
      };
    }

    return pagination;
  }, [isFrontPage, template === null || template === void 0 ? void 0 : template.id, pathname]); // The 'true' template id is a combination of id and post type

  var templateID = "".concat(template === null || template === void 0 ? void 0 : template.id, "-").concat(template === null || template === void 0 ? void 0 : template.postTypeID); // Check if post editor is ready

  var isReady = false;

  if (site && post) {
    isReady = true;
  } // If there is a query, we need to wait for it


  if (template !== null && template !== void 0 && template.query && !query) {
    isReady = false;
  }

  (0, _react.useEffect)(function () {
    var loadQuery = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cleanedUrl, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // TODO: Move to utils function
                cleanedUrl = config === null || config === void 0 ? void 0 : config.source.replace(/\/+$/, '');
                _context.next = 3;
                return _axios.default.post("".concat(cleanedUrl, "/graphql"), {
                  query: template.query
                });

              case 3:
                result = _context.sent;

                if (result !== null && result !== void 0 && result.data) {
                  setQuery(result.data);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function loadQuery() {
        return _ref8.apply(this, arguments);
      };
    }();

    (template === null || template === void 0 ? void 0 : template.query) && loadQuery();
  }, [templateID]);
  (0, _react.useEffect)(function () {
    var loadPost = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(postID) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!previewID) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return _actions.previewActions.getPostPreview({
                  siteID: siteID,
                  previewID: previewID
                }, dispatch, config);

              case 3:
                result = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.next = 8;
                return _actions.postActions.getPost({
                  siteID: siteID,
                  postID: postID
                }, dispatch, config);

              case 8:
                result = _context2.sent;

              case 9:
                if (result) {
                  dispatch({
                    type: "ADD_POST",
                    payload: _objectSpread(_objectSpread({}, result), {}, {
                      siteID: siteID
                    })
                  });
                  dispatch({
                    type: "ADD_EDITOR_POST",
                    payload: _objectSpread(_objectSpread({}, result), {}, {
                      siteID: siteID
                    })
                  });
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function loadPost(_x) {
        return _ref9.apply(this, arguments);
      };
    }();

    postID && loadPost(postID); // Add fresh copy of editor to state

    dispatch({
      type: "ADD_EDITOR_SITE",
      payload: sites[siteID]
    }); // Reset query

    setQuery(null);
    return function cleanup() {
      dispatch({
        type: "CLEAR_EDITOR"
      });
    };
  }, [postID]);
  (0, _reactUseKeypress.default)('Escape', function () {
    !previewID && setSidebarActive(!sidebarActive);
  });

  var handleToggleSidebar = function handleToggleSidebar() {
    if (sidebarActive) {
      _antd.message.open({
        content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Press ", /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
          keyboard: true
        }, "ESC"), " to reopen sidebar")
      });
    }

    setSidebarActive(!sidebarActive);
  };

  var getPostData = function getPostData() {
    // Generate query variable i.e. 'wpPage'
    var nodeType = "wp".concat(post.postTypeID.charAt(0).toUpperCase() + post.postTypeID.slice(1)); // Destructure query data in case user requested more information about post (i.e. wpPost comments)

    var _ref = (query === null || query === void 0 ? void 0 : query.data) || {},
        nodeTypeQueryData = _ref[nodeType],
        otherQueryData = (0, _objectWithoutProperties2.default)(_ref, [nodeType].map(_toPropertyKey)); // Generate default page data


    var data = _objectSpread({}, otherQueryData);

    var nodeTypeData = _objectSpread({
      id: post.id,
      seo: post.seo,
      title: post.title,
      date: post.createdAt,
      featuredImage: post.featuredImage,
      postTypeID: post.postTypeID
    }, (0, _utils.formatTaxonomiesForEditor)(post, site));

    data[nodeType] = _objectSpread(_objectSpread({}, nodeTypeQueryData), nodeTypeData);
    var acfData = (0, _utils.formatFieldsToProps)({
      global: false,
      content: post.content,
      site: site,
      template: template
    });

    if (post.postTypeID === 'page') {
      (0, _lodash.set)(data, "".concat(nodeType, ".template.acf"), acfData);
    } else {
      (0, _lodash.set)(data, "".concat(nodeType, ".acf"), acfData);
    }

    return data;
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PageWrapper.default, {
    template: !!Component && (post === null || post === void 0 ? void 0 : post.content),
    sidebarActive: sidebarActive
  }, postID ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isReady ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!Component && post !== null && post !== void 0 && post.content ? /*#__PURE__*/_react.default.createElement(Component, {
    jamCMS: {
      sidebar: sidebarActive,
      sidebarWidth: 320
    },
    data: getPostData(),
    pageContext: {
      themeOptions: (0, _utils.formatFieldsToProps)({
        global: true,
        themeOptions: fields === null || fields === void 0 ? void 0 : fields.themeOptions,
        content: site === null || site === void 0 ? void 0 : site.themeOptions,
        site: site,
        template: template
      }),
      pagination: pagination
    }
  }) : /*#__PURE__*/_react.default.createElement(EmptyContainer, {
    className: "jam-cms"
  }, /*#__PURE__*/_react.default.createElement(_antd.Empty, {
    imageStyle: {
      height: 120
    },
    description: 'No Template'
  }))) : /*#__PURE__*/_react.default.createElement(_Loader.default, null)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.cloneElement(defaultComponent, {
    pageContext: {
      pagination: pagination,
      themeOptions: (0, _utils.formatFieldsToProps)({
        themeOptions: fields === null || fields === void 0 ? void 0 : fields.themeOptions,
        content: site === null || site === void 0 ? void 0 : site.themeOptions,
        site: site
      })
    }
  }))), previewID && /*#__PURE__*/_react.default.createElement(PreviewBanner, {
    children: "Preview",
    type: "primary"
  }), sidebarActive && /*#__PURE__*/_react.default.createElement(_EditorSidebar.default, {
    className: "jam-cms",
    editable: !!Component,
    onToggleSidebar: handleToggleSidebar
  }));
};

var EmptyContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  text-align: center;\n"])));

var PreviewBanner = (0, _styledComponents.default)(_antd.Button)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  left: 0;\n  top: 50%;\n  z-index: 9999;\n  transform: rotate(270deg) translate(-50%, 50%);\n  transform-origin: left;\n"])));
var _default = PostEditor;
exports.default = _default;